import "../scss/main.scss";

import Vue from "vue";
import * as VueGoogleMaps from "gmap-vue";
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";
import "element-closest/browser";
import "element-remove";
import "picturefill";
import cssVars from "css-vars-ponyfill";
import Cookiewall from "./components/cookiewall";
import { setFormDatalayer } from "./utilities/datalayer";
import "./components/responsive-table";

/**
 * Global Vue JS instance.
 */
const appRoots = document.querySelectorAll(".app");

appRoots.forEach((appRoot) => {
    new Vue({
        components: {
            LifecycleDonutBlock: () =>
                import(
                    /* WebpackChunkName: "lifecycle-donut-block" */ "../vue/LifecycleDonutBlock"
                ),
        },
    }).$mount(appRoot);
});

// Should be replace but keep for tracking
if (document.querySelector("#app") !== null) {
    new Vue({
        components: {
            StoreLocator: () =>
                import(/* webpackChunkName: "store-locator" */ "../vue/components/StoreLocator"),
            CropAverages: () =>
                import(/* webpackChunkName: "crop-averages" */ "../vue/CropAverages"),
            GrassConfigurator: () =>
                import(/* webpackChunkName: "grass-configurator" */ "../vue/GrassConfigurator"),
            CornConfigurator: () =>
                import(/* webpackChunkName: "corn-configurator" */ "../vue/CornConfigurator"),
            SwineScan: () => import(/* webpackChunkName: "swine-scan" */ "../vue/SwineScan"),
        },
    }).$mount("#app");
}
// End

Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyBLitJrOwMyR4moehRjYm8-fI6NK8z6mnA", // Temporary API key, retreive from backend.
        libraries: "places", // This is required if you use the Autocomplete plugin
    },
});

const initFormSubmit = () => {
    // Check if form is an EPiServerForm
    if (typeof $$epiforms !== "undefined") {
        $$epiforms(document).ready(function myfunction() {
            $$epiforms(".EPiServerForms").on("formsSubmitted", function (event) {
                if (event.isFinalizedSubmission && event.isSuccess) {
                    const currentForm = $$epiforms(this).get(0);
                    // We have our custom dataLayer object, we could also have this code somewhere: window.dataLayer = window.dataLayer || []; and then use that
                    if (typeof dataLayer !== "undefined") {
                        dataLayer.push({
                            event: "form-submit",
                            "form-id": currentForm.id,
                        });

                        const data = currentForm.closest(".formbox")?.dataset;

                        if (data?.formCategory?.toLowerCase() === "newsletter") {
                            const fieldsets = currentForm.querySelectorAll("fieldset");

                            for (const fieldset of fieldsets) {
                                if (
                                    fieldset.querySelector("legend")?.textContent?.toLowerCase() ===
                                    "mijn interesses"
                                ) {
                                    // Get all checkboxes.
                                    const checkboxes = fieldset.querySelectorAll("input:checked");
                                    const values = [...checkboxes].map((x) => {
                                        return x
                                            .closest(".mktoFieldWrap")
                                            ?.querySelector("label.mktoLabel")
                                            ?.textContent.trim() // get the label text and remove whitespace
                                            .replace("*", ""); // remove asterisk
                                    });

                                    data["checkbox_category_checked"] = values.join(", ");
                                    break;
                                }
                            }
                        }

                        dataLayer.push(setFormDatalayer(data));

                        if (currentForm.hasAttribute("data-form-popup")) {
                            dataLayer.push({
                                event: "virtual-page",
                                virtualurl: `${window.location}/popupform/sent`,
                            });

                            const oneYearFromNow = new Date();
                            oneYearFromNow.setTime(
                                oneYearFromNow.getTime() + 365 * 24 * 60 * 60 * 1000
                            );
                            document.cookie = `popupDismissed=true; path=/; expires=${oneYearFromNow.toGMTString()}`;
                        }
                    }
                }
            });
        });
    }

    // If form is marketo we set events a bit differently.
    document.addEventListener("DOMContentLoaded", function () {
        // Select the target node where the form will be added
        const targetNodes = document.querySelectorAll(".marketo-form");

        targetNodes.forEach((targetNode) => {
            // Create a new MutationObserver instance. This is used, becuase the marketo form is loaded Async.
            const observer = new MutationObserver(function (mutations) {
                const forms = document.querySelectorAll(".mktoForm");

                forms.forEach((form) => {
                    // After the form is loaded we can stop observing for the form.
                    observer.disconnect();

                    const id = form.id.replace("mktoForm_", "");
                    const mktoForm = MktoForms2.getForm(id);
                    let pushed = false; // This variable is used to prevent spamming of the dataLayer

                    if (mktoForm) {
                        mktoForm.onValidate((isValid) => {
                            // We need to check if the form is valid, otherswise a GTM event is triggered while the form is not submitted yet.
                            if (isValid) {
                                mktoForm.onSubmit((currentForm) => {
                                    // Push data to the dataLayer
                                    if (!pushed) {
                                        dataLayer.push({
                                            event: "form-submit",
                                            "form-id": currentForm.getValues().munchkinId,
                                        });

                                        const form = currentForm.getFormElem()[0];
                                        const data = form.closest(".formbox")?.dataset;

                                        // check if from is newsletter
                                        const isNewsletter =
                                            data?.formCategory?.toLowerCase() === "newsletter";

                                        const datalayerData = setFormDatalayer(data);

                                        if (isNewsletter) {
                                            const fieldsets = form.querySelectorAll("fieldset");

                                            for (const fieldset of fieldsets) {
                                                if (
                                                    fieldset
                                                        .querySelector("legend")
                                                        ?.textContent?.toLowerCase() ===
                                                    "mijn interesses"
                                                ) {
                                                    // Get all checkboxes.
                                                    const checkboxes =
                                                        fieldset.querySelectorAll("input:checked");

                                                    const values = [...checkboxes].map((x) => {
                                                        return x
                                                            .closest(".mktoFieldWrap")
                                                            ?.querySelector("label.mktoLabel")
                                                            ?.textContent.trim() // get the label text and remove whitespace
                                                            .replace("*", ""); // remove asterisk
                                                    });
                                                    datalayerData["checkbox_category_checked"] =
                                                        values.join(", ");
                                                    break;
                                                }
                                            }
                                        }
                                        dataLayer.push(datalayerData);

                                        const newsletterPopup =
                                            document.querySelector(".newsletter-popup");
                                        const popup = document.querySelector("#dialog-popup");

                                        if (newsletterPopup || popup) {
                                            dataLayer.push({
                                                event: "virtual-page",
                                                virtualurl: window.location + "/popupform/sent",
                                            });

                                            const d = new Date();
                                            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 12);
                                            if (newsletterPopup !== null) {
                                                document.cookie =
                                                    "newsletterDismissed=true;path=/;expires=" +
                                                    d.toGMTString();
                                            } else if (popup !== null) {
                                                document.cookie =
                                                    "popupDismissed=true;path=/;expires=" +
                                                    d.toGMTString();
                                            }
                                        }

                                        pushed = true;
                                    }
                                });
                            }
                        });
                    }
                });
            });

            // Start observing mutations in the target node
            observer.observe(targetNode, { childList: true, subtree: true });
        });
    });
};
initFormSubmit();

/**
 * Imports async Js files from /components folder
 * Usage:   Create a Class inside /components/{component-name}/index.js
 *          On DOM element set data-component="{component-name}"
 */

function createComponents() {
    const COMPONENT_ATTR = "data-component";
    const COMPONENTS = document.querySelectorAll(`[${COMPONENT_ATTR}]`);

    COMPONENTS.forEach((component) => {
        const COMPONENT_NAME = component.getAttribute(COMPONENT_ATTR);
        import(/* webpackChunkName: "[request]" */ `./components/${COMPONENT_NAME}`).then((c) => {
            new c.default(component);
        });
    });
}

function showNewsletterPopup() {
    const newsletter = document.querySelector(".newsletter-popup");
    if (newsletter !== null) {
        const close = newsletter.querySelector(".newsletter-popup__close");
        const d = new Date();

        close.addEventListener("click", function () {
            newsletter.classList.remove("show");
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * 12);
            document.cookie = "newsletterDismissed=true;path=/;expires=" + d.toGMTString();
        });

        const myScrollFunc = function () {
            const cookie = document.cookie.match(
                "(^|;) ?" + "newsletterDismissed" + "=([^;]*)(;|$)"
            );
            const y = window.scrollY;
            if (cookie === null && y >= document.body.scrollHeight / 2 - 200) {
                newsletter.classList.add("show");
            }
        };

        window.addEventListener("scroll", myScrollFunc);
    }
}

/**
 * Init CSS vars ponyfill.
 */
cssVars();

createComponents();
window.addEventListener("load", showNewsletterPopup);

new Cookiewall();
